import {
  ORG_PICKER_LIMIT,
  findExactOrg,
} from '@/components/OrgPicker/orgPickerState'
import { useSearchOrganizations } from '@/generated/http-clients/v3ApiComponents'
import type { OrgSearchResult } from '@/generated/http-clients/v3ApiSchemas'
import { ORG_SEARCH_MIN_LENGTH } from '@/helpers/orgSearch'

export type ConfirmedOrgState =
  | { status: 'pending' }
  | { status: 'confirmed'; org: OrgSearchResult }
  | { status: 'unconfirmed' }

export function useConfirmedOrg(orgId: string): ConfirmedOrgState {
  const enabled = orgId.length >= ORG_SEARCH_MIN_LENGTH
  const query = useSearchOrganizations(
    { queryParams: { q: orgId, limit: ORG_PICKER_LIMIT } },
    { enabled, staleTime: Number.POSITIVE_INFINITY },
  )
  const results = query.data?.outcome === 'ok' ? query.data.results : []
  const found = findExactOrg(orgId, results)
  if (found) {
    return { status: 'confirmed', org: found }
  }
  if (enabled && query.data === undefined && !query.isError) {
    return { status: 'pending' }
  }
  return { status: 'unconfirmed' }
}
